import { useTranslation } from "react-i18next";

const BrandBanner = (props) => {

    const { t } = useTranslation();

    // const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}`);

    return (
        <div className="participation-app-brand-banner">
            <div className="participation-app-brand-banner-content">
                <div className="participation-app-brand-banner-content__image">
                    <picture>
                        <source srcSet="/themes/custom/barrio_pepsico_joypepsico/assets/images/snacks-canister/canister-products.webp" type="image/webp" />
                        <img src="/themes/custom/barrio_pepsico_joypepsico/assets/images/snacks-canister/canister-products.png" alt="Snacks Canister" />
                    </picture>
                </div>
                <div className="participation-app-brand-banner-content__text">
                    <h4>{t("Lift the lid on good times")}</h4>
                    <p>{t("Enjoy your faves now in a new pack format - easy to share and take everywhere. Discover why they're the perfect fit for every occasion.")}</p>
                    <a className="btn btn-primary" href="/newsharingpack/product-overview">{t("Discover our products")}</a>
                </div>
            </div>
        </div>
    )
}

export default BrandBanner;